/* FUKUI — the finish picker inside the samples quick-view (assets/finish-picker.js).
   The product pages carry a small dialog for the finish samples (#smModal, built by
   sections/main-product.liquid). This adds the same picker the samples page has: three
   pieces of the catalogue drawn in line, and the three sample photos as buttons. Nothing
   is coloured until a click.
   The photos are taken from the dialog's own thumbnails, so swapping the product's
   images in the admin changes this too. No dependency on mount-anim.js.

   Where it sits: inside the dialog's grid, as a full-width third row. On a desktop that
   is where it always was — under photo and text, with the three sample tiles drawn
   under the coffee table as the control. On a phone the grid is one column and the
   drawing takes the second slot, right under the photo and its thumbnails, before the
   text — and it carries no tiles of its own: at half scale they were 20 px smudges that
   nobody could hit. The thumbnails, 52 px and already there, are the control; the three
   finish photos among them colour the pieces. */
(function () {
  'use strict';

  var CSS = '.fp{border-top:1px solid var(--rule);padding-top:14px}'
    + '.sm-grid > .fp{grid-column:1 / -1;margin-top:0}'
    + '.fp svg{width:100%;height:auto;display:block;overflow:hidden}'
    + '.fp .o{fill:none;stroke:var(--ink);stroke-width:1.4}'
    + '.fp .i{fill:none;stroke:var(--ink);stroke-width:.9}'
    + '.fp .floor{fill:none;stroke:var(--ink);stroke-width:1.2}'
    + '.fp .hatch{fill:none;stroke:var(--ink);stroke-width:.7;opacity:.45}'
    + '.fp .nm{font-family:var(--mono);font-size:13px;font-weight:500;letter-spacing:.2em;fill:var(--ink);transition:fill .4s}'
    + '.fp .nm.waiting{fill:var(--rule)}'
    + '.fp .hint{font-family:var(--mono);font-size:9px;font-weight:500;letter-spacing:.16em;fill:var(--cinnabar)}'
    + '.fp .kn{font-family:var(--mono);font-size:8px;letter-spacing:.12em;fill:var(--ink-2)}'
    + '.fp .ky{cursor:pointer}'
    + '.fp .ky .frame{fill:none;stroke:var(--ink);stroke-width:1;transition:stroke .25s,stroke-width .25s}'
    + '.fp .ky:hover .frame{stroke:var(--cinnabar)}'
    + '.fp .ky.on .frame{stroke:var(--cinnabar);stroke-width:2.2}'
    + '.fp .ky .bar{fill:var(--cinnabar);opacity:0;transition:opacity .3s}'
    + '.fp .ky.on .bar{opacity:1}'
    + '.fp .ky .lift{transition:transform .25s cubic-bezier(.3,0,.2,1)}'
    + '.fp .ky:hover .lift,.fp .ky.on .lift{transform:translateY(-3px)}'
    + '.fp .ky.on .kn{fill:var(--ink)}'
    /* the phone: type scaled for a viewBox that is drawn at about half size, and the
       drawing moved up between the photo column and the text column */
    + '.fp svg.m .nm{font-size:20px}'
    + '.fp svg.m .hint{font-size:14px}'
    + '@media (max-width:640px){'
    +   '.sm-grid > .fp{order:1}'
    +   '.sm-grid > div:nth-of-type(2){order:2}'
    + '}';

  var FLOOR = 122;
  var PIECES = [
    { cx: 112, w: 76, top: FLOOR - 70, leg: 8, kind: 'box' },
    { cx: 320, w: 124, top: FLOOR - 38, leg: 8, kind: 'table' },
    { cx: 520, w: 108, top: FLOOR - 44, leg: 8, kind: 'bench' }
  ];
  /* the tiles: desktop tucked under the table; the phone draws none */
  var GEO = {
    desk:  { tiles: true, ks: 38, ky: 140, kx: [262, 320, 378], h: 200, hint: 'A SAMPLE' },
    phone: { tiles: false, h: 138, hint: 'A SAMPLE ABOVE' }
  };
  var n = function (v) { return Math.round(v * 10) / 10; };

  /* the oak areas of each piece: what a finish fills, and what the outline traces */
  function parts(p) {
    var x0 = p.cx - p.w / 2, x1 = p.cx + p.w / 2, r = [];
    if (p.kind === 'box') { r.push([x0, p.top, p.w, FLOOR - p.leg - p.top]);
      r.push([x0 + 5, FLOOR - p.leg, 8, p.leg]); r.push([x1 - 13, FLOOR - p.leg, 8, p.leg]); }
    if (p.kind === 'table') { r.push([x0, p.top, p.w, 10]);
      r.push([x0 + 12, p.top + 10, 8, FLOOR - p.top - 10]); r.push([x1 - 20, p.top + 10, 8, FLOOR - p.top - 10]); }
    if (p.kind === 'bench') { r.push([x0, p.top, p.w, 11]);
      r.push([x0 + 3, p.top + 11, 9, FLOOR - p.top - 11]); r.push([x1 - 12, p.top + 11, 9, FLOOR - p.top - 11]); }
    return r;
  }
  function outline(p) {
    var x0 = p.cx - p.w / 2, x1 = p.cx + p.w / 2, s = '';
    parts(p).forEach(function (r) { s += '<rect class="o" x="' + n(r[0]) + '" y="' + n(r[1]) + '" width="' + n(r[2]) + '" height="' + n(r[3]) + '"/>'; });
    if (p.kind === 'box') s += '<path class="i" d="M' + n(x0 + 5) + ' ' + n(p.top + 22) + 'H' + n(x1 - 5) + '"/>';
    return s;
  }
  /* the wood, cropped to the middle of the sample photo so no background shows */
  function wood(url, x, y, w, h) {
    return '<svg x="' + n(x) + '" y="' + n(y) + '" width="' + n(w) + '" height="' + n(h) + '" viewBox="320 320 896 896" preserveAspectRatio="xMidYMid slice"><image href="' + url + '" width="1600" height="1600"/></svg>';
  }

  function build(fins, g, tapWord) {
    var s = '', f, k, i, KS = g.ks, KY = g.ky, KX = g.kx;
    s += '<defs>';
    PIECES.forEach(function (p, i) { s += '<clipPath id="fpc' + i + '">';
      parts(p).forEach(function (r) { s += '<rect x="' + n(r[0]) + '" y="' + n(r[1]) + '" width="' + n(r[2]) + '" height="' + n(r[3]) + '"/>'; });
      s += '</clipPath>'; });
    s += '</defs>';
    s += '<path class="floor" d="M40 ' + FLOOR + 'H600"/>';
    for (k = 44; k < 596; k += 10) s += '<path class="hatch" d="M' + k + ' ' + (FLOOR + 6) + 'L' + (k + 5) + ' ' + FLOOR + '"/>';
    PIECES.forEach(function (p, i) {
      var x0 = p.cx - p.w / 2;
      s += '<g><g clip-path="url(#fpc' + i + ')">';
      for (f = 0; f < 3; f++) s += '<g data-wd="' + i + '_' + f + '" style="opacity:0">' + wood(fins[f].url, x0 - 3, p.top - 3, p.w + 6, FLOOR - p.top + 6) + '</g>';
      s += '</g>' + outline(p) + '</g>';
    });
    s += '<text class="nm waiting" data-fp="name" x="14" y="20">PICK A FINISH</text>';
    s += '<text class="hint" data-fp="hint" x="14" y="36">' + tapWord + ' ' + g.hint + '</text>';
    for (f = 0; f < 3 && g.tiles; f++) {
      s += '<g class="ky" data-ky="' + f + '">'
        + '<rect x="' + (KX[f] - KS / 2 - 5) + '" y="' + (KY - 6) + '" width="' + (KS + 10) + '" height="' + (KS + 30) + '" fill="transparent"/>'
        + '<g class="lift">' + wood(fins[f].url, KX[f] - KS / 2, KY, KS, KS)
        + '<rect class="frame" x="' + (KX[f] - KS / 2) + '" y="' + KY + '" width="' + KS + '" height="' + KS + '"/>'
        + '<rect class="bar" x="' + (KX[f] - KS / 2) + '" y="' + (KY + KS + 4) + '" width="' + KS + '" height="2.5"/>'
        + '<text class="kn" x="' + KX[f] + '" y="' + (KY + KS + 18) + '" text-anchor="middle">' + fins[f].name + '</text>'
        + '</g></g>';
    }
    return s;
  }

  function init(modal) {
    /* the three finish photos come from the dialog's own thumbnails */
    var fins = [], want = [['NATURAL', /natural/i], ['BROWN', /brown/i], ['BLACK', /black/i]];
    var thumbs = Array.prototype.slice.call(modal.querySelectorAll('[data-sm-src]'));
    want.forEach(function (w) {
      var hit = thumbs.filter(function (b) { return w[1].test(b.dataset.smSrc || ''); })[0];
      if (hit) fins.push({ name: w[0], url: (hit.dataset.smSrc || '').replace(/([?&])width=\d+/, '$1width=900'), btn: hit });
    });
    if (fins.length !== 3) return;

    if (!document.getElementById('fp-style')) {
      var st = document.createElement('style'); st.id = 'fp-style'; st.textContent = CSS; document.head.appendChild(st);
    }
    var grid = modal.querySelector('.sm-grid');
    if (!grid) return;

    var phone = window.matchMedia && matchMedia('(max-width: 640px)').matches;
    var touch = window.matchMedia && matchMedia('(hover: none)').matches;
    var g = phone ? GEO.phone : GEO.desk, tapWord = touch ? 'TAP' : 'CLICK';

    var box = document.createElement('div');
    box.className = 'fp';
    box.innerHTML = '<svg class="' + (phone ? 'm' : 'd') + '" viewBox="0 0 640 ' + g.h + '" preserveAspectRatio="xMidYMid meet" role="img" aria-label="The three finishes on three pieces of furniture">' + build(fins, g, tapWord) + '</svg>';
    grid.appendChild(box);

    var cur = -1;
    var name = box.querySelector('[data-fp="name"]'), hint = box.querySelector('[data-fp="hint"]');
    function pick(f) {
      if (f === cur) return;
      PIECES.forEach(function (p, i) {
        var t0 = i * 140;
        box.querySelector('[data-wd="' + i + '_' + f + '"]').animate([{ opacity: 0 }, { opacity: 1 }], { duration: 600, delay: t0, fill: 'forwards', easing: 'ease-out' });
        [0, 1, 2].forEach(function (g) {
          if (g !== f) box.querySelector('[data-wd="' + i + '_' + g + '"]').animate([{ opacity: 1 }, { opacity: 0 }], { duration: 450, delay: t0 + 150, fill: 'forwards' });
        });
      });
      name.setAttribute('class', 'nm');
      name.animate([{ opacity: 0, transform: 'translateY(6px)' }, { opacity: 1, transform: 'none' }], { duration: 400, fill: 'forwards', easing: 'ease-out' });
      setTimeout(function () { name.textContent = fins[f].name; }, 110);
      hint.textContent = tapWord + ' ANOTHER'; hint.style.opacity = .5;
      Array.prototype.forEach.call(box.querySelectorAll('.ky'), function (g, i) { g.classList.toggle('on', i === f); });
      cur = f;
    }
    /* a tile presses the matching thumbnail: the dialog swaps its photo to that
       finish, and the thumbnail's own listener below colours the pieces. One path
       for both, whichever of the two a visitor uses — and on a phone, where the
       thumbnails are hidden, the tiles are the only way to see the other photos. */
    Array.prototype.forEach.call(box.querySelectorAll('.ky'), function (g, i) {
      g.addEventListener('click', function () { fins[i].btn.click(); pick(i); });
    });
    fins.forEach(function (fin, i) { fin.btn.addEventListener('click', function () { pick(i); }); });
  }

  function start() {
    var modal = document.getElementById('smModal');
    if (modal) init(modal);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
